import vueform_de from '@vueform/vueform/locales/de'
import vueform_en from '@vueform/vueform/locales/en'
import festiware_de from '../../newform/vue-src/locales/de';
import festiware_en from '../../newform/vue-src/locales/en';
import vueform from '@vueform/vueform/dist/vueform'
import { defineConfig } from '@vueform/vueform'
import {staticSelectsPlugin, phoneValidator, emailValidator, dateValidator} from './plugins';

function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }
    return mergeDeep(target, ...sources);
}

const de = mergeDeep(vueform_de, festiware_de);
const en = mergeDeep(vueform_en, festiware_en);
de.validation.phoneNumber = 'Dies ist kein gültiges Telefonnummer-Format.';
en.validation.phoneNumber = 'This is not a valid phone number format.';

export default defineConfig({
    showRequired: ['label', 'placeholder', 'floating'],
    validateOn: 'change',
    displayMessages: true,
    theme: vueform,
    locales: { de, en },
    locale: 'de',
    plugins: [staticSelectsPlugin],
    rules: {
        phoneNumber: phoneValidator,
        email: emailValidator,
        // Overrides Vueform's built-in rule of the same name — see plugins.js.
        date: dateValidator
    },
    endpoints: {
        url: false,
        removeFile: false,
        uploadTempFile: (file, el$) => el$.form$.providers.doOctoberRequest('onSubmitFile', {file}, true),
        removeTempFile: (file, el$) => el$.form$.providers.doOctoberRequest('onDeleteFile', {id: el$.value}),
    }
})

